<kendo-grid [kendoGridBinding]="data"
            [resizable]="true"
            [sortable]="false"
            [reorderable]="false"
            [groupable]="false"
            [navigable]="true"
            [selectable]="selectableSettings"
            style="width:70vw;">
  @for (column of colSettings; track column.field) {
  <kendo-grid-column field="{{column.field}}"
                     title="{{column.title | translate}}"
                     [filter]="column.type"
                     [width]="column.width">

  </kendo-grid-column>
  }
</kendo-grid>

